import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { sendWebVitalsToAnalytics } from './reportWebVitals';

// MetaMask hatalarını yakala
window.addEventListener('error', function(event) {
  if (event.error && event.error.message && event.error.message.includes('MetaMask')) {
    console.log('MetaMask hatası yakalandı, görmezden geliniyor...');
    event.preventDefault();
    return false;
  }
});

window.addEventListener('unhandledrejection', function(event) {
  if (event.reason && event.reason.message && event.reason.message.includes('MetaMask')) {
    console.log('MetaMask promise hatası yakalandı, görmezden geliniyor...');
    event.preventDefault();
    return false;
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <App />
);

reportWebVitals(sendWebVitalsToAnalytics);
